import { render, staticRenderFns } from "./customTableComponent.vue?vue&type=template&id=51e60c8e&scoped=true&"
import script from "./customTableComponent.vue?vue&type=script&lang=js&"
export * from "./customTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./customTableComponent.vue?vue&type=style&index=0&id=51e60c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e60c8e",
  null
  
)

export default component.exports